import * as v from 'valibot';

import { EMaoMaintenanceBadge, EMaoMaintenanceName } from '#shared';

import { maoAirportSchema } from './maoAirport.schema';

import type { MaoMaintenance, MaoMaintenanceType } from '../types';

export const maoMaintenanceTypeSchema: v.GenericSchema<MaoMaintenanceType> =
  v.object({
    Name: v.enum(
      EMaoMaintenanceName,
      issue => `@WARNING: Unexpected maintenance name ${issue.input}`,
    ),
    OpsBoardBadge: v.enum(
      EMaoMaintenanceBadge,
      issue => `@WARNING: Unexpected ops board badge ${issue.input}`,
    ),
  });

export const maoMaintenanceSchema: v.GenericSchema<MaoMaintenance> = v.object({
  MaintenanceType: maoMaintenanceTypeSchema,
  Airport: maoAirportSchema,
  Id: v.number('Maintenance ID is missing'),
  AircraftId: v.number('Aircraft ID is missing'),
  ScheduledStartDateAndTimeUtc: v.string(
    'Scheduled start datetime UTC is missing',
  ),
  ScheduledStartDateAndTimeUtcUnix: v.number(
    'Scheduled start datetime UTC unix is missing',
  ),
  ActualStartDateAndTimeUtc: v.optional(
    v.string('Invalid actual start datetime UTC'),
  ),
  ActualStartDateAndTimeUtcUnix: v.nullable(
    v.number('Invalid actual start datetime UTC unix'),
  ),
  ScheduledEndDateAndTimeUtc: v.string('Scheduled end datetime UTC is missing'),
  ScheduledEndDateAndTimeUtcUnix: v.number(
    'Scheduled end datetime UTC unix is missing',
  ),
  ActualEndDateAndTimeUtc: v.optional(
    v.string('Invalid actual end datetime UTC'),
  ),
  ActualEndDateAndTimeUtcUnix: v.nullable(
    v.number('Invalid actual end datetime UTC unix'),
  ),
});
